import { Footer } from "@servicepro/jobsite-components";
import type React from "react";
// oxlint-disable-next-line import/default -- Vite virtual module (vite-site-data.plugin.ts) the linter cannot resolve
import siteData from "virtual:site-data";

/**
 * The published footer: its stored config, with the badge decided by the API's effective
 * flag (forced on for Free) rather than the config, which never carries it. Rendered from
 * the config alone, every published site kept the badge whatever its owner chose.
 */
const SiteFooter = (props: React.ComponentProps<typeof Footer>): React.JSX.Element => <Footer {...props} showServiceProBadge={siteData.business?.showServiceProBadge !== false} businessId={siteData.businessId} />;

export { SiteFooter };
